import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Row, Col } from 'antd'
import { gql, graphql } from 'react-apollo'
// import PropTypes from 'prop-types'
import moment from 'moment'
import './style.css'
import { ProfileBox } from '~/styles'
class ProfilePage extends Component {
  render () {
    // console.log(this.props.data)
    const { currentUser } = this.props.data
    function toDate (time) {
      return moment(time).format('DD/MM/YYYY')
    }
    if (!currentUser) {
      return <h1>Loading</h1>
    }
    const { profile } = currentUser
    return (
      <ProfileBox>
        <div className="inProfileBox" style={{ width: '900px' }}>
          <div className="profileIcon">
            <img src="/ico-userregister.png" alt="" />
            <span className="profileName">
              {' '}{`${profile.firstName} ${profile.lastName}`}
            </span>
            <Link to="/profile/edit" className="editProfile">Edit</Link>
          </div>
          <div className="shapeTopic profilePage">
            <span className="shapeTitle">Profile Info</span>
          </div>
          <Row>
            <Col xs={24} md={12}>
              <div className="profileInfo">
                <p className="profileInfoTitle">Birth Date</p>
                <div className="profileInfoDataBox">
                  <span className="profileInfoData">
                    {toDate(profile.birthDate)}
                  </span>
                </div>
              </div>
            </Col>
            <Col xs={24} md={12}>
              <div className="profileInfo">
                <p className="profileInfoTitle">Gender</p>
                <div className="profileInfoDataBox">
                  <span className="profileInfoData">
                    {profile.gender}
                  </span>
                </div>
              </div>
            </Col>
            <Col xs={24} md={12}>
              <div className="profileInfo">
                <p className="profileInfoTitle">Telephone</p>
                <div className="profileInfoDataBox">
                  <span className="profileInfoData">
                    {profile.telephone}
                  </span>
                </div>
              </div>
            </Col>
            <Col xs={24} md={12}>
              <div className="profileInfo">
                <p className="profileInfoTitle">Nationality</p>
                <div className="profileInfoDataBox">
                  <span className="profileInfoData">
                    {profile.nationality}
                  </span>
                </div>
              </div>
            </Col>
          </Row>
          {/* <div className="shape profilePage">
                        <span className='shapeTitle'>Contract Info</span>
                    </div>
                    <Row>
                        <Col xs={24} md={12}>
                            <div className='profileInfo'>
                                <p className='profileInfoTitle'>Address</p>
                                <div className='profileInfoDataBox'>
                                     <span className='profileInfoData'>
                                        1234 BKK
                                    </span>
                                </div>
                            </div>
                        </Col>
                        <Col xs={24} md={12}>
                            <div className='profileInfo'>
                                <p className='profileInfoTitle'>Province</p>
                                <div className='profileInfoDataBox'>
                                   <span className='profileInfoData'>
                                        Bangkok
                                    </span>
                                </div>
                            </div>
                        </Col>
                        <Col xs={24} md={12}>
                            <div className='profileInfo'>
                                <p className='profileInfoTitle'>Country</p>
                                <div className='profileInfoDataBox'>
                                   <span className='profileInfoData'>
                                        Thai
                                    </span>
                                </div>
                            </div>
                        </Col>
                        <Col xs={24} md={12}>
                            <div className='profileInfo'>
                                <p className='profileInfoTitle'>Tel</p>
                                <div className='profileInfoDataBox'>
                                   <span className='profileInfoData'>
                                        0851469556
                                    </span>
                                </div>
                            </div>
                        </Col>
                        <Col xs={24} md={12}>
                            <div className='profileInfo'>
                                <p className='profileInfoTitle'>E-mail</p>
                                <div className='profileInfoDataBox'>
                                   <span className='profileInfoData'>
                                        {email}
                                    </span>
                                </div>
                            </div>
                        </Col>
                    </Row> */}
        </div>
      </ProfileBox>
    )
  }
}

const currentUser = gql`query {
  currentUser {
    _id
    email
    profile {
      _id
      firstName
      lastName
      birthDate
      nationalId
      nationality
      gender
      telephone
    }
  }
}`

const ProfilePageWithData = graphql(currentUser, {
  options: { fetchPolicy: 'network-only' }
})(ProfilePage)

export default ProfilePageWithData



// WEBPACK FOOTER //
// ./src/App/ProfilePage/ProfilePage.js